/** The general agent's full page. */
export const GENERAL_AGENT_PAGE_PATH = '/dispatcher/general-agent'

/** Where minimizing the full page goes when there is no page to go back to. */
export const GENERAL_AGENT_FALLBACK_PATH = '/dispatcher'
